import { apiClient } from './ApiClient';

/**
 * Simple wrapper exposing ApiClient methods for Pinia stores.
 */
export const piniaApi = {
  get: apiClient.get.bind(apiClient),
  post: apiClient.post.bind(apiClient),
  put: apiClient.put.bind(apiClient),
  delete: apiClient.delete.bind(apiClient)
};
